import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import PhoneVerification from '../../../components/PhoneVerification.js';

const Spinner = () => (
  <div style={styles.spinner}></div>
);

const StartCampaign = () => {
  // משתנה domain – עדכן לפי הסביבה
  const domain = "https://server.hazran.online";

  // State קיים לטופס יצירת הקמפיין
  const [accountBalance, setAccountBalance] = useState(0);
  const [adText, setAdText] = useState('');
  const [quantity, setQuantity] = useState('100');
  const [costPerUnit, setCostPerUnit] = useState('0.3');
  const [suggestions, setSuggestions] = useState([]);
  const [selectedSuggestion, setSelectedSuggestion] = useState('');

  // State לזיהוי ואימות טלפון
  const [isVerified, setIsVerified] = useState(false);

  const [campaignSubmitAttempted, setCampaignSubmitAttempted] = useState(false);

  // State למודלים
  const [showBudgetOptions, setShowBudgetOptions] = useState(false);
  const [showCouponModal, setShowCouponModal] = useState(false);
  const [showSavedCardModal, setShowSavedCardModal] = useState(false);
  const [showNewCardModal, setShowNewCardModal] = useState(false);
  const [savedCardBudget, setSavedCardBudget] = useState('');
  const [last4Digits, setLast4Digits] = useState('');
  const [couponCode, setCouponCode] = useState('');
  const [newCardAmount, setNewCardAmount] = useState('');
  const [showMultipleReferralsModal, setShowMultipleReferralsModal] = useState(false);

  // State להסבר על עלות ליחידה
  const [showCostExplanation, setShowCostExplanation] = useState(false);

  // States לספינרים
  const [loadingStartCampaign, setLoadingStartCampaign] = useState(false);
  const [loadingSuggestions, setLoadingSuggestions] = useState(false);
  const [loadingAddBudget, setLoadingAddBudget] = useState(false);
  const [loadingCoupon, setLoadingCoupon] = useState(false);

  // State עבור בדיקת מסך קטן
  const [isMobile, setIsMobile] = useState(window.innerWidth < 600);

  // State לאפשר שיחה יוצאת מידית
  const [allowImmediateCall, setAllowImmediateCall] = useState(false);
  const [showImmediateCallModal, setShowImmediateCallModal] = useState(false);

  // State עבור הפניות מרובות
  const [allowMultipleReferrals, setAllowMultipleReferrals] = useState(false);
  // מערך שורות הפניה – כל שורה: { id, phone, label }
  const [referralRows, setReferralRows] = useState([]);
  const [validationError, setValidationError] = useState(null);
  // -------------------------
  // State לפתיחות משפט הפרסום
  const [advertisingOpenings, setAdvertisingOpenings] = useState([]);
  const [selectedAdvertisingOpeningIndex, setSelectedAdvertisingOpeningIndex] = useState(null);
  const [showAdvertisingOpenings, setShowAdvertisingOpenings] = useState(false);
  // -------------------------

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 600);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    document.body.style.backgroundImage = 'url("/background.jpg")';
    document.body.style.backgroundSize = 'cover';
    document.body.style.backgroundPosition = 'center';
    const link = document.createElement('a');
    link.href = 'https://hazran.online';
    link.textContent = ' עזרן - נתב בינה מלאכותית טלפוני hazran.online';
    link.style.display = 'block';
    link.style.textAlign = 'center';
    link.style.marginTop = '20px';
    link.style.color = '#ffffff';
    link.style.textDecoration = 'none';
    link.style.fontSize = '14px';
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    document.body.appendChild(link);
    return () => {
      document.body.style.backgroundImage = '';
      document.body.style.backgroundSize = '';
      document.body.style.backgroundPosition = '';
      document.body.removeChild(link);
    };
  }, []);

  useEffect(() => {
    if (isVerified) updateAccountBalance();
  }, [isVerified]);

  useEffect(() => {
    const token = Cookies.get('verificationToken');
    const phoneNumber = Cookies.get('phoneNumber');
    if (token && phoneNumber) {
      setIsVerified(true);
    }
  }, []);

  // useEffect לקריאת הפתיחות מהשרת
  useEffect(() => {
    fetch(`${domain}/site_api/advertising_management_interface/get_advertising_opening`, {
      method: 'GET'
    })
      .then(response => response.json())
      .then(data => {
        if (data && data.advertising_opening && Array.isArray(data.advertising_opening)) {
          setAdvertisingOpenings(data.advertising_opening);
          if (data.advertising_opening.length > 0) {
            const randomIndex = Math.floor(Math.random() * data.advertising_opening.length);
            setSelectedAdvertisingOpeningIndex(randomIndex);
          }
        }
        
      })
      .catch(error => console.error('Error fetching advertising openings:', error));
      }, [domain]);
  

  useEffect(() => {
    // ← שונה: מיפוי כל row לאובייקט מלא במקום {} ריק
    let currentDigits = {};
    if (allowMultipleReferrals) {
      referralRows.forEach(row => {
        currentDigits[row.id] = {
          action: "call",                       // ← שונה: הוסף action
          phone_number: row.phone               // ← שונה: הוסף phone_number
        };
      });
    } else if (allowImmediateCall) {
      currentDigits[1] = {
        action: "call",                         // ← שונה: הוסף action
        phone_number: Cookies.get('phoneNumber')// ← שונה: הוסף phone_number
      };
    }

    // ← שונה: משתמש ב־computedAdText() ולא ב־adText
    const finalText = computedAdText();      
    const msg = validateAdTextLength(finalText, currentDigits);
    setValidationError(msg);
  }, [
    adText,
    allowImmediateCall,
    allowMultipleReferrals,
    referralRows
  ]);


  const isVerifiedRecheck = () => {
    const token = Cookies.get('verificationToken');
    const phoneNumber = Cookies.get('phoneNumber');
    if (!(token && phoneNumber)) {
      alert("יש לבצע כניסה שינית");
      setIsVerified(false);
      return false;
    }
    return true;
  };

  const updateAccountBalance = () => {
    fetch(`${domain}/site_api/advertising_management_interface/account_balance`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        phone: Cookies.get('phoneNumber'),
        token: Cookies.get('verificationToken')
      })
    })
      .then(response => response.json())
      .then(data => setAccountBalance(data.balance))
      .catch(error => console.error('Error fetching account balance:', error));
  };

  const generateSuggestions = () => {
    isVerifiedRecheck();
    setLoadingSuggestions(true);
    fetch(`${domain}/site_api/advertising_management_interface/ad_suggestions`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        phone: Cookies.get('phoneNumber'),
        token: Cookies.get('verificationToken')
      }),
      signal: (s => (setTimeout(() => s.abort(), 120000), s.signal))(new AbortController())
    })
      .then(response => response.json())
      .then(data => setSuggestions(data.suggestions))
      .catch(error => console.error('Error fetching suggestions:', error))
      .finally(() => setLoadingSuggestions(false));
  };

  const R = parseFloat(quantity) * parseFloat(costPerUnit);
  let totalCost;
  if (isNaN(R)) {
    totalCost = 0;
  } else if (allowMultipleReferrals) {
    totalCost = R * (referralRows.length + 2);
  } else if (allowImmediateCall) {
    totalCost = R * 3;
  } else {
    totalCost = R;
  }
  totalCost = totalCost.toFixed(2);

  const computedAdText = () => {
    let text = adText;
    if (allowImmediateCall && !allowMultipleReferrals) {
      if (!text.includes("לְחַץ 1")) {
        text += ", לְמַעֲבָר עכשיו, לְחַץ 1";
      }
    }
    if (allowMultipleReferrals) {
      referralRows.forEach(row => {
        if (row.label && !text.includes(`ל-${row.label} לְחַץ ${row.id}`)) {
          text += `, ל-${row.label} לְחַץ ${row.id}`;
        }
      });
    }
    return text;
  };

  const startNewCampaign = () => {
    if (!isVerifiedRecheck()) { return; }
    setCampaignSubmitAttempted(true);
    if (allowMultipleReferrals) {
      for (const row of referralRows) {
        if (!row.label.trim() || !row.phone.trim() || !/^\d+$/.test(row.phone)) {
          alert("יש למלא שם ומספר טלפון תקין לכל שורת הפניה");
          return;
        }
      }
    }
    const totalCostFloat = parseFloat(totalCost);
    if ((parseFloat(costPerUnit) || 0) < 0.1 || (parseInt(quantity) || 0) < 50) {
      alert("מינימום 50 יחידות, ומינימום 10 אגורות ליחידה");
      return;
    }
    
    if (totalCostFloat > parseFloat(accountBalance)) {
      const userChoice = window.confirm(
        `עלות הקמפיין (סה"כ עלות: ${totalCostFloat} ₪) גבוהה מהתקציב הקיים (${accountBalance} ₪).\nהאם תרצה לעבור לחלון "הוסף תקציב"?`
      );
      if (userChoice) setShowBudgetOptions(true);
      return;
    }

    const finalAdText = computedAdText();

    const payload = {
      token: Cookies.get('verificationToken'),
      phone: Cookies.get('phoneNumber'),
      adText: finalAdText,
      quantity,
      costPerUnit,
      // מוסיף את אינדקס הפתיחה שנבחר (או האקראי)
      advertising_opening_index: selectedAdvertisingOpeningIndex
    };

    if (allowImmediateCall && !allowMultipleReferrals) {
      payload.digits = { "1": { action: "call", phone_number: Cookies.get('phoneNumber') } };
    }
    if (allowMultipleReferrals) {
      payload.digits = {};
      referralRows.forEach(row => {
        payload.digits[String(row.id)] = { action: "call", phone_number: row.phone };
      });
    }
    const validateAdTextLengthMessage = validateAdTextLength(finalAdText, payload.digits || {});
    if (validateAdTextLengthMessage) {
      alert(validateAdTextLengthMessage);
      return;
    }

    setLoadingStartCampaign(true);
    fetch(`${domain}/site_api/advertising_management_interface/start_campaign`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          alert("קמפיין הושק בהצלחה");
          updateAccountBalance();
          setCampaignSubmitAttempted(false);
        } else {
          alert("הייתה בעיה בהפעלת הקמפיין: " + data.message);
        }
      })
      .catch(error => {
        console.error("Error starting campaign:", error);
        alert("הייתה בעיה בהפעלת הקמפיין");
      })
      .finally(() => setLoadingStartCampaign(false));
  };

  const handleMouseDown = (e) => { e.currentTarget.style.transform = 'scale(0.98)'; };
  const handleMouseUpOrLeave = (e) => { e.currentTarget.style.transform = 'scale(1)'; };

  function validateAdTextLength(adText, digits) {
    const baseLimit = 60;
    let additionalLimit = 0;
  
    if (digits && typeof digits === 'object') {
      additionalLimit = 24 * Object.keys(digits).length;
    }
  
    const allowedLength = baseLimit + additionalLimit;
    const adTextWithoutNikud = adText.normalize("NFD").replace(/[\u0591-\u05C7]/g, '');
    const lengthWithoutNikud = adTextWithoutNikud.length;
    
    if (lengthWithoutNikud > allowedLength) {
      return `אורך הפרסום חורג מהתקן. אורך מקסימלי מותר: ${allowedLength} תווים, אורך נוכחי: ${lengthWithoutNikud}`;
    }
    
    return null;
  }

  const handleNewCardPayment = () => {
    if (!newCardAmount || parseFloat(newCardAmount) < 50) {
      alert("סכום מינימלי לתשלום הוא 50, ולא ניתן להשאיר את התיבה ריקה");
      return;
    }
    document.cookie = `service=תקציב פרסום ממשק ניהול; path=/`;
    document.cookie = `amount=${newCardAmount}; path=/`;
    document.cookie = `type=העברה חד פעמית; path=/`;
    document.cookie = `remarks=השרות כולל הזנת תקציב לשימוש בממשק הניהול של הפרסום; path=/`;
    window.location.href = '/getCredit';
  };

  const handleSavedCardBudgetSubmit = () => {
    setLoadingAddBudget(true);
    const payload = {
      token: Cookies.get('verificationToken'),
      phone: Cookies.get('phoneNumber'),
      amount: savedCardBudget,
      last4Digits
    };
    fetch(`${domain}/site_api/advertising_management_interface/add_budget`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          alert("תקציב עודכן בהצלחה");
          setShowSavedCardModal(false);
          updateAccountBalance();
        } else {
          alert("הייתה בעיה בהוספת התקציב: " + data.message);
        }
      })
      .catch(error => {
        console.error("Error adding budget:", error);
        alert("הייתה בעיה בהוספת התקציב");
      })
      .finally(() => setLoadingAddBudget(false));
  };

  const handleCouponSubmit = () => {
    setLoadingCoupon(true);
    const payload = {
      token: Cookies.get('verificationToken'),
      phone: Cookies.get('phoneNumber'),
      coupon: couponCode
    };
    fetch(`${domain}/site_api/advertising_management_interface/enter_coupon`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          alert("קופון הוזן בהצלחה");
          setShowCouponModal(false);
          updateAccountBalance();
        } else {
          alert("הייתה בעיה בהזנת הקופון: " + data.message);
        }
      })
      .catch(error => {
        console.error("Error entering coupon:", error);
        alert("הייתה בעיה בהזנת הקופון");
      })
      .finally(() => setLoadingCoupon(false));
  };

  const handleReferralPhoneChange = (id, newPhone) => {
    setReferralRows(prev =>
      prev.map(row => (row.id === id ? { ...row, phone: newPhone } : row))
    );
  };

  const handleReferralLabelChange = (id, newLabel) => {
    setReferralRows(prev =>
      prev.map(row => (row.id === id ? { ...row, label: newLabel } : row))
    );
  };

  const handleRemoveReferralRow = (id) => {
    setReferralRows(prev => prev.filter(row => row.id !== id));
  };

  const handleAddReferralRow = () => {
    if (referralRows.length > 0 && referralRows[referralRows.length - 1].id === 9) return;
    const newId = referralRows.length > 0 ? referralRows[referralRows.length - 1].id + 1 : 2;
    setReferralRows(prev => [...prev, { id: newId, phone: '', label: '' }]);
  };

  // במידה והמשתמש עדיין לא אומת – נשתמש בקומפוננטת PhoneVerification
  if (!isVerified) {
    return <PhoneVerification domain={domain} onVerified={() => setIsVerified(true)} />;
  }

  return (
    <div style={styles.container}>
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
      <h2 style={styles.header}>יצירת קמפיין</h2>

      
      <div style={styles.fieldRow}>
        <div style={{ ...styles.field, textAlign: 'right', flexGrow: 1 }}>
          <label style={styles.label}>סכום בחשבון:</label>
          <span>{accountBalance} ₪</span>
        </div>
        <button
          onClick={() => {
            isVerifiedRecheck();
            setShowBudgetOptions(true);
          }}
          style={styles.smallButton}
          onMouseDown={handleMouseDown}
          onMouseUp={handleMouseUpOrLeave}
          onMouseLeave={handleMouseUpOrLeave}
        >
          הוסף תקציב
        </button>
      </div>
      <div style={styles.fieldRow}>
        <div style={{ flexGrow: 1 }}>
          <label style={styles.label}>משפט פרסום:</label>
          {/* תצוגת פתיחת משפט הפרסום */}
          <div>
  <button 
    onClick={() => setShowAdvertisingOpenings(!showAdvertisingOpenings)}
    style={{ fontWeight: 'bold', fontSize: '10px', background: 'none',  cursor: 'pointer', color: '#000000' }}
  >
     {advertisingOpenings.length > 0 && selectedAdvertisingOpeningIndex !== null 
        ? advertisingOpenings[selectedAdvertisingOpeningIndex] 
        : ''}
  
  </button>
</div>
{/* תפריט לבחירת פתיחות */}
{showAdvertisingOpenings && advertisingOpenings.length > 0 && (
  <div style={{ fontSize: '10px' }}>
    {advertisingOpenings.map((opening, index) => (
      <label key={index} >
        <input
          type="radio"
          name="advertisingOpening"
          value={index}
          checked={selectedAdvertisingOpeningIndex === index}
          onChange={() => setSelectedAdvertisingOpeningIndex(index)}
        />
        {opening} <br/>
      </label>
    ))}
  </div>
)}

          <input
            type="text"
            value={adText}
            onChange={(e) => setAdText(e.target.value)}
            style={styles.input}
          />
          {validationError && (
                <p style={{ color: 'red', fontSize: '12px', marginTop: '4px' }}>
                  {validationError}
                </p>
              )}
          {allowImmediateCall && (
            <div>
              <label style={styles.label}>פרסום מלא:</label>
              <input
                type="text"
                value={advertisingOpenings[selectedAdvertisingOpeningIndex]+" "+computedAdText()}
                style={styles.input}
              />
            </div>
          )}
          <p style={styles.adviceText}>
            למניעת טעויות הקראה מומלץ לנקד, למעבר לנקדן של דיקטה&nbsp;
            <a href="https://nakdanlive.dicta.org.il/" target="_blank" rel="noopener noreferrer">לחץ כאן</a>
          </p>
        </div>
      </div>
      {suggestions.length > 0 && (
        <div style={styles.suggestions}>
          {suggestions.map((suggestion, index) => (
            <label key={index} style={styles.suggestionLabel}>
              <input
                type="radio"
                name="suggestion"
                value={suggestion}
                checked={selectedSuggestion === suggestion}
                onChange={(e) => {
                  setSelectedSuggestion(e.target.value);
                  setAdText(e.target.value);
                }}
              />
              {suggestion}
            </label>
          ))}
          <br />
        </div>
      )}
      <div style={styles.field}>
        <button
          onClick={generateSuggestions}
          style={{ ...styles.button, width: '50%', margin: '0 auto' }}
          onMouseDown={handleMouseDown}
          onMouseUp={handleMouseUpOrLeave}
          onMouseLeave={handleMouseUpOrLeave}
        >
          {loadingSuggestions ? <Spinner /> : "מחולל הצעות"}
        </button>
      </div>
      <div
        style={
          isMobile
            ? { ...styles.fieldRow, flexDirection: 'column', alignItems: 'flex-start', marginTop: '60px', marginBottom: '60px' }
            : { ...styles.fieldRow, marginTop: '60px', marginBottom: '60px' }
        }
      >
        <div
          style={
            isMobile
              ? { ...styles.smallField, width: '100%', flexDirection: 'column', alignItems: 'flex-start' }
              : { ...styles.smallField, width: '30%' }
          }
        >
          <label style={styles.label}>כמות יחידות:</label>
          <input
            type="number"
            step="100"
            value={quantity}
            onChange={(e) => {
              const newValue = Math.max(50, Math.floor(e.target.value));
              setQuantity(newValue);
            }}
            style={styles.smallInput}
          />
        </div>
        <div
          style={
            isMobile
              ? { ...styles.smallField, width: '100%', flexDirection: 'column', alignItems: 'flex-start' }
              : { ...styles.smallField, width: '30%' }
          }
        >
          <label style={styles.label}>
            עלות ליחידה, בש"ח
            <span style={styles.infoIcon} onClick={() => setShowCostExplanation(true)}>?</span>
          </label>
          <input
            type="number"
            step="0.1"
            value={costPerUnit}
            onChange={(e) => setCostPerUnit(e.target.value)}
            style={styles.smallInput}
          />
        </div>
        <div
          style={
            isMobile
              ? { ...styles.smallField, width: '100%', flexDirection: 'column', alignItems: 'flex-start' }
              : { ...styles.smallField, width: '30%' }
          }
        >
          <label style={styles.label}>סה"כ עלות:</label>
          <input
            type="text"
            readOnly
            value={totalCost}
            style={styles.smallInput}
          />
        </div>
      </div>
      <div style={{ marginBottom: '30px' }}>
        <div style={{ textAlign: 'right', marginBottom: '10px' }}>
          <input
            type="checkbox"
            id="immediateCall"
            checked={allowImmediateCall}
            onChange={(e) => {
              if (e.target.checked) {
                setShowImmediateCallModal(true);
              } else {
                setAllowImmediateCall(false);
                setAllowMultipleReferrals(false);
                setReferralRows([]);
              }
            }}
          />
          <label htmlFor="immediateCall" style={{ marginRight: '8px' }}>
            לאפשר שיחה יוצאת מידית
          </label>
        </div>
        {allowImmediateCall && (
          <div style={{ textAlign: 'right' }}>
            <input
              type="checkbox"
              id="multipleReferrals"
              checked={allowMultipleReferrals}
              onChange={(e) => {
                if (e.target.checked) {
                  setShowMultipleReferralsModal(true);
                } else {
                  setAllowMultipleReferrals(false);
                  setReferralRows([]);
                }
              }}
            />
            <label htmlFor="multipleReferrals" style={{ marginRight: '8px' }}>
              לאפשר הפניות טלפוניות מרובות
            </label>
          </div>
        )}
      </div>
      {showImmediateCallModal && (
        <div style={styles.modalOverlay}>
          <div style={styles.modalContent}>
            <p>
              פרסום עם שיחה יוצאת כרוך בעלות של 3 יחידות, ליחידת פרסום. והוא מומלץ רק לאחר פרסום ראשוני משמעותי רגיל.
            </p>
            <button
              style={styles.modalButton}
              onClick={() => {
                setAllowImmediateCall(true);
                setShowImmediateCallModal(false);
              }}
            >
              אישור
            </button>
            <button
              style={styles.modalButton}
              onClick={() => {
                setAllowImmediateCall(false);
                setShowImmediateCallModal(false);
              }}
            >
              ביטול
            </button>
          </div>
        </div>
      )}
      {showMultipleReferralsModal && (
        <div style={styles.modalOverlay}>
          <div style={styles.modalContent}>
            <p>
              הפניות מרובות כרוכות בעלות 1 יחידה נוספת עבור כל מספר הפניה נוסף, ואינה מומלצת אלא לגופים מוכרים או לאחר פרסום בסיסי מסיבי.
            </p>
            <button
              style={styles.modalButton}
              onClick={() => {
                setAllowMultipleReferrals(true);
                setReferralRows([{ id: 1, phone: Cookies.get('phoneNumber'), label: '' }]);
                setShowMultipleReferralsModal(false);
              }}
            >
              אישור
            </button>
            <button
              style={styles.modalButton}
              onClick={() => {
                setAllowMultipleReferrals(false);
                setShowMultipleReferralsModal(false);
              }}
            >
              ביטול
            </button>
          </div>
        </div>
      )}
      {allowMultipleReferrals && referralRows.length > 0 && (
        <div style={{ marginBottom: '20px', textAlign: 'right' }}>
          {referralRows.map((row) =>
            isMobile ? (
              <div key={row.id} style={{ marginBottom: '12px' }}>
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '4px' }}>
                  <span style={styles.referralPrefix}>ל-</span>
                  <input
                    type="text"
                    placeholder="שם (למשל, מחלקת מכירות)"
                    value={row.label}
                    onChange={(e) => handleReferralLabelChange(row.id, e.target.value)}
                    style={{
                      ...styles.referralLabelInput,
                      borderColor: campaignSubmitAttempted && !row.label.trim() ? 'red' : '#ccc'
                    }}
                  />
                  <span style={styles.referralMidText}> - לְחַץ {row.id},</span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                  <span style={styles.referralPhoneLabel}>טלפון:</span>
                  <input
                    type="text"
                    placeholder="מספר"
                    value={row.phone}
                    onChange={(e) => handleReferralPhoneChange(row.id, e.target.value)}
                    style={{
                      ...styles.referralPhoneInput,
                      borderColor: campaignSubmitAttempted && (!row.phone.trim() || !/^\d+$/.test(row.phone)) ? 'red' : '#ccc'
                    }}
                  />
                  <button onClick={() => handleRemoveReferralRow(row.id)} style={styles.referralRemoveButton}>
                    ✕
                  </button>
                </div>
              </div>
            ) : (
              <div key={row.id} style={styles.referralRow}>
                <span style={styles.referralPrefix}>ל-</span>
                <input
                  type="text"
                  placeholder="שם (למשל, מחלקת מכירות)"
                  value={row.label}
                  onChange={(e) => handleReferralLabelChange(row.id, e.target.value)}
                  style={{
                    ...styles.referralLabelInput,
                    borderColor: campaignSubmitAttempted && !row.label.trim() ? 'red' : '#ccc'
                  }}
                />
                <span style={styles.referralMidText}> - לְחַץ {row.id},</span>
                <span style={styles.referralPhoneLabel}>טלפון:</span>
                <input
                  type="text"
                  placeholder="מספר"
                  value={row.phone}
                  onChange={(e) => handleReferralPhoneChange(row.id, e.target.value)}
                  style={{
                    ...styles.referralPhoneInput,
                    borderColor: campaignSubmitAttempted && (!row.phone.trim() || !/^\d+$/.test(row.phone)) ? 'red' : '#ccc'
                  }}
                />
                <button onClick={() => handleRemoveReferralRow(row.id)} style={styles.referralRemoveButton}>
                  ✕
                </button>
              </div>
            )
          )}
          <div style={{ textAlign: 'center', marginTop: '10px' }}>
            {(referralRows.length === 0 || referralRows[referralRows.length - 1].id < 9) && (
              <button onClick={handleAddReferralRow} style={styles.referralAddButton}>
                ➕
              </button>
            )}
          </div>
        </div>
      )}
      <div style={styles.field}>
        <button
          onClick={startNewCampaign}
          style={styles.button}
          onMouseDown={handleMouseDown}
          onMouseUp={handleMouseUpOrLeave}
          onMouseLeave={handleMouseUpOrLeave}
        >
          {loadingStartCampaign ? <Spinner /> : "התחל קמפיין"}
        </button>
      </div>
      {showBudgetOptions && (
        <div style={styles.modalOverlay}>
          <div style={styles.modalContent}>
            <h3>בחר אפשרות להוספת תקציב</h3>
            <button
              style={styles.modalButton}
              onClick={() => {
                setShowBudgetOptions(false);
                setShowSavedCardModal(true);
              }}
            >
              הוסף תקציב מכרטיס אשראי שמור במערכת
            </button>
            <button
              style={styles.modalButton}
              onClick={() => {
                setShowBudgetOptions(false);
                setShowNewCardModal(true);
              }}
            >
              תשלום בכרטיס אשראי חדש
            </button>
            <button
              style={styles.modalButton}
              onClick={() => {
                setShowBudgetOptions(false);
                setShowCouponModal(true);
              }}
            >
              הזן קופון
            </button>
            <button style={styles.modalButton} onClick={() => setShowBudgetOptions(false)}>
              סגור
            </button>
          </div>
        </div>
      )}
      {showCouponModal && (
        <div style={styles.modalOverlay}>
          <div style={styles.modalContent}>
            <h3>הזן קופון</h3>
            <label style={styles.modalLabel}>קוד קופון:</label>
            <input
              type="text"
              value={couponCode}
              onChange={(e) => setCouponCode(e.target.value)}
              style={styles.modalInput}
            />
            <button style={styles.modalButton} onClick={handleCouponSubmit}>
              {loadingCoupon ? <Spinner /> : "שלח"}
            </button>
            <button style={styles.modalButton} onClick={() => setShowCouponModal(false)}>
              סגור
            </button>
          </div>
        </div>
      )}
      {showSavedCardModal && (
        <div style={styles.modalOverlay}>
          <div style={styles.modalContent}>
            <h3>הוסף תקציב מכרטיס אשראי שמור</h3>
            <label style={styles.modalLabel}>הזן סכום להוספה:</label>
            <input
              type="number"
              value={savedCardBudget}
              onChange={(e) => setSavedCardBudget(e.target.value)}
              style={styles.modalInput}
            />
            <label style={styles.modalLabel}>הזן 4 ספרות אחרונות:</label>
            <input
              type="text"
              maxLength="4"
              value={last4Digits}
              onChange={(e) => setLast4Digits(e.target.value)}
              style={styles.modalInput}
            />
            <button style={styles.modalButton} onClick={handleSavedCardBudgetSubmit}>
              {loadingAddBudget ? <Spinner /> : "שלח"}
            </button>
            <button style={styles.modalButton} onClick={() => setShowSavedCardModal(false)}>
              סגור
            </button>
          </div>
        </div>
      )}
      {showNewCardModal && (
        <div style={styles.modalOverlay}>
          <div style={styles.modalContent}>
            <h3>תשלום בכרטיס אשראי חדש</h3>
            <label style={styles.modalLabel}>הזן סכום לתשלום:</label>
            <input
              type="number"
              value={newCardAmount}
              onChange={(e) => setNewCardAmount(e.target.value)}
              style={styles.modalInput}
              min="50"
              required
            />
            <button style={styles.modalButton} onClick={handleNewCardPayment}>
              הזן פרטי כרטיס אשראי
            </button>
            <button style={styles.modalButton} onClick={() => setShowNewCardModal(false)}>
              סגור
            </button>
          </div>
        </div>
      )}
      {showCostExplanation && (
        <div style={styles.modalOverlay}>
          <div style={styles.modalContent}>
            <h3>כיצד מחושבת עלות הקמפיין?</h3>
              עלות הפרסום בפרסום רגיל מחושבת לפי מספר היחידות כפול עלות ליחידה, לכן אם תתמחר יחידה ב-30 אגורות ותזמין 100 פרסומים העלות הכוללת תיהיה 30 ש"ח
              <br />• פרסום עם שיחה ישירה ופרסום מרובה שלוחות, כרוך בתשלום גבוה יותר
            <br /><br />
            <h3>בכמה לתמחר?</h3>
            המחיר לקליק משפיע על תדירות שידורי המודעה. מחיר נמוך (כמו 0.1) עלול לגרום לכך שהמודעה תשודר לעיתים נדירות, בעוד שמחיר גבוה יותר יגביר את כמות השידורים. 
            <br /><b> מומלץ לבחור מחיר בין 0.3 ל-0.5 שקלים ליחידה.</b>
              <br /><br />
              <h3>איזה סוג מודעה עדיפה?</h3>
              • למודעות עם אפשרות שיחה ישירה יש יתרון גדול, הלקוח יכול ישר, מיתוך שמיעת המודעה, ליצור שיחת רכישה עם בעל העסק, אבל היא גם הרבה יותר יקרה
              <br />• בפרסום ראשוני, מודעה זו פחות אפקטיבית 
              <br />• אך לאחר שהלקוחות מכירים את העסק – האפקטיביות עולה
              <br /><b>• לכן ההמלצה שלנו 
              <br />• להתחיל מפרסום מסיבי בסיסי, עם הפרסומות הרגילות
              <br />• ואחר כך לעבור לפרסומות עם שיחה ישירה</b>
              <br />• הפניות מרובות מיועדות למותגים או לחברות גדולות
              <button style={styles.modalButton} onClick={() => setShowCostExplanation(false)}>
              סגור
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

const styles = {
  container: {
    maxWidth: '600px',
    margin: '50px auto',
    padding: '20px',
    backgroundColor: 'white',
    borderRadius: '8px',
    boxShadow: '0 0 10px rgba(0,0,0,0.1)',
    textAlign: 'center'
  },
  header: {
    marginBottom: '30px',
    color: '#333'
  },
  fieldRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '25px',
    minHeight: '60px'
  },
  field: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginBottom: '25px',
    minHeight: '60px'
  },
  label: {
    marginBottom: '5px',
    fontWeight: 'bold',
    fontSize: '14px'
  },
  input: {
    padding: '8px',
    width: '90%',
    border: '1px solid #ccc',
    borderRadius: '4px',
    fontSize: '14px',
    height: '36px',
    boxSizing: 'border-box'
  },
  button: {
    padding: '10px 15px',
    backgroundColor: '#007BFF',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    width: '100%',
    transition: 'transform 0.1s ease'
  },
  smallButton: {
    padding: '8px 12px',
    backgroundColor: '#28a745',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '14px',
    transition: 'transform 0.1s ease'
  },
  smallField: {
    width: '48%',
    display: 'flex',
    alignItems: 'center'
  },
  smallInput: {
    padding: '8px',
    width: '100%',
    border: '1px solid #ccc',
    borderRadius: '4px',
    fontSize: '14px',
    height: '36px',
    boxSizing: 'border-box'
  },
  suggestions: {
    marginTop: '25px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  suggestionLabel: {
    display: 'block',
    margin: '5px 0'
  },
  modalOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000
  },
  modalContent: {
    backgroundColor: 'white',
    padding: '30px',
    borderRadius: '8px',
    textAlign: 'center',
    maxWidth: '400px',
    width: '90%'
  },
  modalButton: {
    padding: '10px 15px',
    backgroundColor: '#007BFF',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    width: '100%',
    marginTop: '10px',
    marginBottom: '10px'
  },
  modalInput: {
    padding: '8px',
    width: '80%',
    border: '1px solid #ccc',
    borderRadius: '4px',
    fontSize: '14px',
    height: '36px',
    boxSizing: 'border-box',
    marginTop: '10px',
    marginBottom: '10px'
  },
  modalLabel: {
    marginTop: '10px',
    marginBottom: '5px',
    fontWeight: 'bold',
    fontSize: '14px',
    display: 'block'
  },
  spinner: {
    border: '4px solid #f3f3f3',
    borderTop: '4px solid #3498db',
    borderRadius: '50%',
    width: '24px',
    height: '24px',
    animation: 'spin 1s linear infinite',
    margin: '0 auto'
  },
  infoIcon: {
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '16px',
    height: '16px',
    border: '1px solid #007BFF',
    borderRadius: '50%',
    fontSize: '10px',
    color: '#007BFF',
    backgroundColor: '#fff',
    verticalAlign: 'middle',
    marginLeft: '5px'
  },
  adviceText: {
    fontSize: '12px',
    color: '#666',
    textAlign: 'center',
    margin: '2px 0 0 0'
  },
  previewText: {
    fontSize: '12px',
    color: '#555',
    marginTop: '4px'
  },
  referralRow: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '8px',
    fontSize: '12px'
  },
  referralPrefix: {
    marginRight: '4px'
  },
  referralLabelInput: {
    padding: '4px',
    width: '120px',
    border: '1px solid #ccc',
    borderRadius: '4px',
    fontSize: '12px',
    marginRight: '4px'
  },
  referralMidText: {
    marginRight: '8px'
  },
  referralPhoneLabel: {
    marginRight: '4px'
  },
  referralPhoneInput: {
    padding: '4px',
    width: '80px',
    border: '1px solid #ccc',
    borderRadius: '4px',
    fontSize: '12px',
    marginRight: '8px'
  },
  referralRemoveButton: {
    backgroundColor: '#dc3545',
    border: 'none',
    color: 'white',
    borderRadius: '50%',
    width: '24px',
    height: '24px',
    cursor: 'pointer',
    fontSize: '14px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  referralAddButton: {
    backgroundColor: '#28a745',
    border: 'none',
    color: 'white',
    borderRadius: '50%',
    width: '32px',
    height: '32px',
    cursor: 'pointer',
    fontSize: '18px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
};

export default StartCampaign;
